import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NAV } from "@/constants/testIds";
import { ChevronRight } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Agents", href: "#agents", tid: NAV.linkAgents },
    { label: "How it works", href: "#how", tid: NAV.linkHow },
    { label: "Pricing", href: "#pricing", tid: NAV.linkPricing },
    { label: "FAQ", href: "#faq", tid: NAV.linkFaq },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-void/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#top" data-testid={NAV.logo} className="flex items-center group">
          <BrandLogo compact />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.tid}
              className="text-sm text-mymech-grey hover:text-white transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <Link
          to="/login"
          data-testid={NAV.ctaLaunch}
          className="group inline-flex items-center gap-2 px-4 h-10 rounded-brand border border-white/15 bg-mymech-blue/10 hover:bg-mymech-blue hover:text-mymech-black hover:border-mymech-blue transition-all text-sm font-medium text-white"
        >
          Launch console
          <ChevronRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </header>
  );
};

export default Navbar;
